/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */
//import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import {BrowserRouter, Route} from "react-router-dom";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import 'react-toastify/dist/ReactToastify.css';
import './Assets/css/styles_admin.css'
import './Assets/css/style.css'
import './Assets/js/scripts'
import Home from './Components/Pages/Home'
import Nav from "./Components/Includes/Nav";
import SideBar from "./Components/Includes/SideBar";
import Footer from "./Components/Includes/Footer";
import Login from "./Components/Pages/Login";
import {useEffect, useState} from "react";
import OrderList from "./Components/Pages/OrderList";
import Auth from "./Auth";
import ServiceList from "./Components/Pages/ServiceList";
import PaypalSettings from "./Components/Pages/PaypalSettings";
import Revenue from "./Components/Pages/Revenue";

function App() {
  const [url, setUrl] = useState('')
  useEffect(() => {
    setUrl(window.location.pathname)
    console.log(url)
  }, [])
  return (
      <>
        {url == '/login' ?
            <BrowserRouter>
              <Route path={'/login'} component={Login}/>
            </BrowserRouter> :
            <BrowserRouter>
              <Nav/>
              <div id="layoutSidenav">
                <SideBar/>
                <div id="layoutSidenav_content">
                  <Auth  path={'/demo'} component={Home}/>
                  <Auth exact path={'/'} component={Home}/>
                  <Auth path={'/order-list'} component={OrderList}/>
                  <Auth path={'/service-list'} component={ServiceList}/>
                  <Auth path={'/paypal-settings'} component={PaypalSettings}/>
                  <Auth path={'/revenue'} component={Revenue}/>

                  <Footer/>
                </div>
              </div>
            </BrowserRouter>
        }
      </>
  );
}

export default App;
